// Media query used to determine if the device is on a retina display
const RETINA_MEDIA =
    '(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),' + '(min-device-pixel-ratio: 1.5)';

export const PLATFORMS = {
    windows: 'windows',
    mac: 'mac',
    unix: 'unix',
    linux: 'linux',
    iOS: 'ios',
    android: 'android',
};

export const getPlatform = () => {
    if (!global.navigator) return null;

    const { userAgent, appVersion = '' } = navigator;

    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) return PLATFORMS.iOS;
    if (userAgent.match(/Android/i)) return PLATFORMS.android;

    if (appVersion.indexOf('Win') !== -1) return PLATFORMS.windows;
    if (appVersion.indexOf('Mac') !== -1) return PLATFORMS.mac;
    if (appVersion.indexOf('X11') !== -1) return PLATFORMS.unix;
    if (appVersion.indexOf('Linux') !== -1) return PLATFORMS.linux;

    return null;
};

/**
 * Determines if the current device is retina or not.
 *
 * @return {Boolean} true if the current device is a retina display.
 */
export const isRetina =
    global.window && (window.devicePixelRatio > 1 || (window.matchMedia && window.matchMedia(RETINA_MEDIA).matches));
export const isApple = getPlatform() === PLATFORMS.mac || getPlatform() === PLATFORMS.iOS;
export const isAndroid = () => getPlatform() === PLATFORMS.android;
export const isMobile = () => getPlatform() === PLATFORMS.iOS || isAndroid();
export const isIpadDevice = () => /iPad/i.test(global.navigator?.userAgent && isTouch());
export const isPhone = () => (getPlatform() === PLATFORMS.iOS && !isIpadDevice()) || isAndroid();
export const isIOS = () => getPlatform() === PLATFORMS.iOS;
export const isTablet = () =>
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        global.navigator.userAgent.toLowerCase(),
    );

export const isTouch = () =>
    global.window && 'ontouchstart' in window && ((global.navigator && navigator.maxTouchPoints) || 0) > 2;

export const isIpad = () => !!(/Safari/i.test(global.navigator?.userAgent) && isTouch());

export const getDeviceSupportsMouse = () => matchMedia('(pointer:fine)').matches;

export const getUserAgent = () => global.window?.navigator?.userAgent || '';
export const isBrowser = (testRegex) => testRegex.test(getUserAgent());
export const isSafari = () => !!global.window?.safari;
export const isFirefox = () => isBrowser(/Firefox/g);
export const isChrome = () => isBrowser(/Chrome/g);
